import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    margin: 'auto',
    maxWidth: 700,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  map: {
    '& path': {
      stroke: theme.palette.common.white,
      strokeWidth: 1,
      fill: theme.palette.primary.lighter,
      outline: 'none',
      transition: 'all 0.1s ease-in-out',
      '&[aria-checked="true"]': {
        fill: theme.palette.primary.light,
        opacity: 0.3,
        '&:hover': {
          opacity: 0.6,
        },
      },
    },
  },
  spain: {
    width: '100%',
    height: 300,
    [theme.breakpoints.up('sm')]: {
      height: 400,
    },
    [theme.breakpoints.up('md')]: {
      height: 500,
    },
  },
  canaryIsland: {
    marginRight: 'auto',
    width: '25%',
    maxWidth: 200,
    height: 40,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: fade(theme.palette.primary.main, 0.2),
    [theme.breakpoints.up('sm')]: {
      height: 100,
    },
  },
  ceuta: {
    width: 30,
    height: 30,
    padding: 10,
    borderRadius: '50%',
    backgroundColor: fade(theme.palette.primary.lighter, 0.8),
    position: 'absolute',
    top: 270,
    left: '28%',
    [theme.breakpoints.up('sm')]: {
      top: 385,
      left: '35%',
    },
    [theme.breakpoints.up('md')]: {
      top: 485,
    },
    '&:hover': {
      zIndex: theme.zIndex.drawer,
    },
  },
  melilla: {
    width: 30,
    height: 30,
    padding: 10,
    borderRadius: '50%',
    backgroundColor: fade(theme.palette.primary.lighter, 0.8),
    position: 'absolute',
    top: 280,
    left: '42%',
    [theme.breakpoints.up('sm')]: {
      top: 395,
      left: '45%',
    },
    [theme.breakpoints.up('md')]: {
      top: 500,
    },
  },
}))

export default useStyles
